const getLocaleDirection = (locale: string): 'ltr' | 'rtl' => {
	try {
		return ['ar', 'fa'].includes(locale) ? 'rtl' : 'ltr'
	} catch {
		return 'ltr'
	}
}

export default getLocaleDirection
